import { grey } from '@mui/material/colors';
import IconeAdvogado from '../components/sessao/icones/IconeAdvogado';
import SituacaoIdDescricaoBase from './SituacaoIdDescricaoBase';
import { SITUACAO_INSCRICAO_ADVOGADO } from './SituacaoInscricaoAdvogado';

/**
 * Enum para situações de inscrições de advogados no processo.
 *
 * @readonly
 * @constant
 * @enum {Object.<string, Object>}
 */
// prettier-ignore
export const SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO = {
    COM_ADV_INSCRITO:                     { id: 'COM_ADV_INSCRITO',                     descricao: 'Pelo menos um advogado inscrito',                   cor: 'black',                                  corFundo: 'transparent' },
    COM_ADV_SEM_INFORMACAO_PRESENCA:      { id: 'COM_ADV_SEM_INFORMACAO_PRESENCA',      descricao: 'Pelo menos um advogado sem informação de presença', cor: grey[200],                                corFundo: grey[900]     },
    COM_ADV_PRESENTE:                     { id: 'COM_ADV_PRESENTE',                     descricao: 'Pelo menos um advogado presente',                   cor: SITUACAO_INSCRICAO_ADVOGADO.PRESENTE.cor, corFundo: 'transparent' },
    COM_ADV_PRESENTE_PRESENCIALMENTE:     { id: 'COM_ADV_PRESENTE_PRESENCIALMENTE',     descricao: 'Pelo menos um advogado presente presencialmente',   cor: SITUACAO_INSCRICAO_ADVOGADO.PRESENTE.cor, corFundo: 'transparent' },
    COM_ADV_PRESENTE_TELEPRESENCIALMENTE: { id: 'COM_ADV_PRESENTE_TELEPRESENCIALMENTE', descricao: 'Pelo menos um advogado presente remotamente',       cor: SITUACAO_INSCRICAO_ADVOGADO.PRESENTE.cor, corFundo: 'transparent' },
    COM_ADV_AUSENTE:                      { id: 'COM_ADV_AUSENTE',                      descricao: 'Pelo menos um advogado ausente',                    cor: SITUACAO_INSCRICAO_ADVOGADO.AUSENTE.cor,  corFundo: 'transparent' },
    COM_TODOS_ADV_AUSENTES:               { id: 'COM_TODOS_ADV_AUSENTES',               descricao: 'TODOS os advogados ausentes',                       cor: SITUACAO_INSCRICAO_ADVOGADO.AUSENTE.cor,  corFundo: 'transparent' }
};

/**
 * @classdesc Facilita o acesso às propriedades e valores da enum de situações de inscrições de advogados no processo.
 * @readonly
 */
export default class SituacaoInscricoesAdvogadosProcesso {
    static situacaoBase = new SituacaoIdDescricaoBase(SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO);
    static MSG_ERRO_IDENTIFICACAO_SITUACAO_INSCRICOES_ADVOGADOS_PROCESSO =
        'Não foi possível identificar a situação das inscrições em relação ao processo.';

    static getDescricao(id) {
        return SituacaoInscricoesAdvogadosProcesso.situacaoBase.getDescricao(id);
    }

    static getCor(id) {
        return SituacaoInscricoesAdvogadosProcesso.situacaoBase.getValorPropriedade(id, 'cor');
    }

    static getCodigo(id) {
        return SituacaoInscricoesAdvogadosProcesso.situacaoBase.getValorPropriedade(id, 'codigo');
    }

    static getIcone(id) {
        const tamanhoIcone = '22px';
        let obj = SituacaoInscricoesAdvogadosProcesso.situacaoBase.getObjectById(id);

        return (
            <IconeAdvogado
                title={obj.descricao}
                removerEstiloPadrao
                style={{
                    width: tamanhoIcone,
                    height: tamanhoIcone,
                    color: obj.cor,
                    fill: obj.cor,
                    backgroundColor: obj.corFundo
                }}
            />
        );
    }
}
